import { Input } from 'antd';
import { useEffect, useRef, useState } from 'react';
import libphonenumber from 'libphonenumber-js';
import CountryCode from './countryCode.json';

const countryCode = CountryCode.sort((a, b) => parseInt(a.dial_code.slice(1)) > parseInt(b.dial_code.slice(1)) ? 1 : -1).filter((v, i, a) => a.findIndex(v2 => (v2.dial_code === v.dial_code)) === i)


const defaultLangToCountry = (_lang) => {
    switch (_lang) {
        case "fr":
            return "FR"
        case "en":
            return "US"
        case "he":
            return "IL"
    }
}

export default function PhoneInput({value, onChange, defaultLang, placeholder,disabled}) {

    const [country, setCountry] = useState(defaultLang ? defaultLangToCountry(defaultLang) : "FR")
    const [v, setV] = useState(null)

    const isMountedRef = useRef(false);


    useEffect(() => {

        const phoneNumber = getPhoneNumber(v, country)

        if (value && value !== phoneNumber) {
            const _phoneNumber = libphonenumber(value)

            if (_phoneNumber && _phoneNumber.isValid()) {
                //console.log(value,"IS VALIDE PHONE NUMBER")

                const countryData = countryCode.find(i => i.dial_code === "+" + _phoneNumber.countryCallingCode)
                if (countryData) {
                    setCountry(countryData.code)
                    setV(_phoneNumber.nationalNumber)
                }
            }else{
                //console.log(value,"IS NOT VALIDE PHONE NUMBER")
            }
        }

    }, [value]);

    useEffect(() => {
        if(isMountedRef.current)
        {
            const prefix = getPrefixFromCountry(country)
            const phoneNumber = libphonenumber(prefix + v)

            if (phoneNumber) {
                if (phoneNumber.isValid()) {
                    const international = phoneNumber.formatInternational().replaceAll(" ", "")
                    //console.log("VALID NUMBER", international)
                    onChange(international)
                } else {
                    //console.log("INVALID NUMBER")
                    onChange(NaN)
                }
            } else {
                //console.log("NOT NUMBER")
                if (value) {
                    onChange(null)
                }
            }
        }
    }, [v, country]);


    useEffect(() => {
        isMountedRef.current = true;
    }, []);


    const getPrefixFromCountry = (_country = "FR") => {
        return countryCode.find(i => i.code === _country)?.dial_code || "+33"
    }

    const getPhoneNumber = (_value, _country = "FR") => {
        const prefix = getPrefixFromCountry(_country)

        const phoneNumber = libphonenumber(prefix + _value, _country)

        if (phoneNumber && phoneNumber.isValid()) {
            const international = phoneNumber.formatInternational().replaceAll(" ", "")
            return international
        }

        return null
    }


    const onInputChange = (_value = null) => {
        let _finalValue = null
        if (_value) {
            _finalValue = _value
        }

        if (_finalValue && _finalValue?.startsWith("0")) {
            _finalValue = _finalValue.slice(1)
        }


        if (_finalValue && _finalValue.startsWith("+")) {
            const phoneNumber = libphonenumber(_finalValue)
            if (phoneNumber && phoneNumber.isValid()) {
                _finalValue = phoneNumber.nationalNumber.replaceAll(" ", "")
                setCountry(phoneNumber.country)
            }
        }

        setV(_finalValue)
    }

    //console.log("COUNTRY",country,getPrefixFromCountry(country))
    //console.log("VALUE",v)

    return (
        <Input
            disabled={disabled}
            value={v}
            placeholder={placeholder || "6 XX XX XX XX"}
            onChange={(e) => onInputChange(e.target.value)}
            autoComplete="tel"

            addonBefore={(
                <select
                    disabled={disabled}
                    style={{width: 70, border: 0, outline: 0}}
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                >
                    {countryCode.map(i => {
                        return (
                            <option value={i.code}>{i.dial_code}</option>
                        )
                    })}
                </select>
            )}
        />
    )
}
